// extracted by mini-css-extract-plugin
export default {"headings":"About_headings__O-KvJ","title":"About_title__rDDoF"};